import { render, staticRenderFns } from "./GetraenkeProdukte.vue?vue&type=template&id=0f9daa08&scoped=true"
import script from "./GetraenkeProdukte.vue?vue&type=script&lang=js"
export * from "./GetraenkeProdukte.vue?vue&type=script&lang=js"
import style0 from "./GetraenkeProdukte.vue?vue&type=style&index=0&id=0f9daa08&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9daa08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9daa08')) {
      api.createRecord('0f9daa08', component.options)
    } else {
      api.reload('0f9daa08', component.options)
    }
    module.hot.accept("./GetraenkeProdukte.vue?vue&type=template&id=0f9daa08&scoped=true", function () {
      api.rerender('0f9daa08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GetraenkeProdukte.vue"
export default component.exports